import React from 'react'
import ImageGallery from '../components/ImageGallery'
import images from '../images/images'

const imagesModal = images['urbanSketching'][0];
const imagesThumb = images["urbanSketching"][1];

const sketchbook = () => (
    <ImageGallery imagesModal={imagesModal} imagesThumb={imagesThumb} tabName="URBAN SKETCHING" />
)

export default sketchbook;



// WEBPACK FOOTER //
// ./src/pages/urban-sketching.js